import { FileUploadStatus, FileUploadError, FileUploadStatusMessage } from '../enums';
import { getRandomUuidV4 } from "../../common";
import { FileUploadStatusType } from '@mitchell/react.component.ux';
import { FileUploadConstants } from '../constants';
export class FileHelperService {
    static mapToThumbnailFileInfo(fileInfo, thumbnail, status, maxImageSize) {
        return Object.assign(Object.assign({}, fileInfo), { file: thumbnail, fileName: FileHelperService.getThumbnailFileName(fileInfo.fileName), fileSizeInBytes: thumbnail.size, id: getRandomUuidV4(), uploadStatus: status, parentId: fileInfo.id, maxImageSize, disableProgressNotification: !FileUploadConstants.ThumbnailUploadProgressNotification, maximumAllowedImageHeight: undefined, maximumAllowedImageWidth: undefined });
    }
    static getThumbnailFileName(fileName) {
        const extensionLocation = fileName.lastIndexOf('.');
        if (extensionLocation !== -1) {
            const fileNameWithoutExtension = fileName.substring(0, extensionLocation);
            const extension = fileName.substring(extensionLocation);
            return `${fileNameWithoutExtension} (thumb)${extension}`;
        }
        return `${fileName} (thumb)`;
    }
}
FileHelperService.isNonCancelledOriginalFile = (fileInfo) => !fileInfo.parentId && fileInfo.uploadStatus !== FileUploadStatus.CANCELLED;
FileHelperService.getUploadStatusMessage = (uploadError) => {
    switch (uploadError) {
        case FileUploadError.MAX_FILE_SIZE_EXCEEDED:
            return FileUploadStatusMessage.UPLOAD_FAILED_FILE_SIZE_MESSAGE;
        case FileUploadError.MAX_FILE_NAME_CHARACTER_LIMIT_EXCEEDED:
            return FileUploadStatusMessage.UPLOAD_FAILED_FILE_NAME_LIMIT_MESSAGE;
        case FileUploadError.INVALID_FILE_TYPE:
            return FileUploadStatusMessage.UPLOAD_FAILED_INVALID_FILE_TYPE_MESSAGE;
        case FileUploadError.MAX_VIDEO_FILE_SIZE_EXCEEDED:
            return FileUploadStatusMessage.UPLOAD_FAILED_VIDEO_FILE_SIZE_MESSAGE;
        case FileUploadError.CARRIER_CUSTOM_MESSAGE:
            return FileUploadStatusMessage.UPLOAD_FAILED_VIDEO_CUSTOM_MESSAGE;
        default:
            return FileUploadStatusMessage.UPLOAD_FAILED_MESSAGE;
    }
};
FileHelperService.isFileUploadDone = (uploadStatus) => uploadStatus === FileUploadStatus.SUCCESS || uploadStatus === FileUploadStatus.FAILED;
FileHelperService.getIsFileUploadDone = (currentFileInfo, thumbnailInfo) => {
    return (FileHelperService.isFileUploadDone(currentFileInfo.uploadStatus) &&
        (!thumbnailInfo || FileHelperService.isFileUploadDone(thumbnailInfo.uploadStatus)));
};
FileHelperService.getIsFileUploadFailed = (currentFileInfo, thumbnailInfo) => {
    if (currentFileInfo.uploadStatus === FileUploadStatus.FAILED) {
        return true;
    }
    return !!thumbnailInfo && thumbnailInfo.uploadStatus === FileUploadStatus.FAILED;
};
FileHelperService.getUploadStatus = (currentFileInfo, thumbnailInfo) => {
    if (FileHelperService.getIsFileUploadDone(currentFileInfo, thumbnailInfo) &&
        FileHelperService.getIsFileUploadFailed(currentFileInfo, thumbnailInfo)) {
        return {
            message: FileHelperService.getUploadStatusMessage(currentFileInfo.uploadError),
            type: FileUploadStatusType.ALERT
        };
    }
    return;
};
FileHelperService.getIsUploadValidationError = (uploadError) => {
    return FileUploadConstants.UploadValidationErrors.some(error => error === uploadError);
};
FileHelperService.dataURLtoFile = (dataURL, filename) => {
    const dataUrlArray = dataURL.split(',');
    const mime = dataUrlArray[0].match(/:(.*?);/)[1];
    const decodedString = atob(dataUrlArray[1]);
    let stringLength = decodedString.length;
    const uint8array = new Uint8Array(stringLength);
    while (stringLength--) {
        uint8array[stringLength] = decodedString.charCodeAt(stringLength);
    }
    return new File([uint8array], filename, { type: mime });
};
//# sourceMappingURL=FileHelperService.js.map